import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchSaleTagList = ({commit}) => {

    axios.get('/saleTag/index.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setSaleTagList', res.data.response)         
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchSaleTagData = ({commit}, payload) => {
   
    commit('toggleLoadingState', true)
    axios.post('/saleTag/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(payload.copy) {
            res.data.response.id = 0
            commit('displaySuccessNotification', {message: 'Data copied!!!'});
        }

        if(res.data.status) {
            
            commit('setSaleTagData', res.data.response)   
            
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetSaleTagData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitSaleTagData = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/saleTag/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteSaleTagData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/saleTag/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchSaleTagList')
            }
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/saleTag/actions.js